import { Box, Card, Checkbox, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../../../styles/theme';

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(136px, 1fr))',
  gap: theme.spacing(1.5),
  padding: theme.spacing(0, 0, 1.5, 0),
}));

export const ProductCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.background.paper,
  ...(theme.palette.mode === 'dark'
    ? {
        boxShadow: 'none',
        border: `1px solid ${theme.palette.divider}`,
        '&:hover': {
          boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.4)}`,
          transform: 'translateY(-2px)',
        },
      }
    : {
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transform: 'translateY(-2px)',
        },
      }),
  transition: 'box-shadow 0.2s ease, transform 0.2s ease',
  cursor: 'pointer',
}));

export const ImageWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  paddingTop: '100%',
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : colors.grey[100],
  overflow: 'hidden',
}));

export const ProductThumbnail = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}));

export const CardCheckbox = styled(Checkbox)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(0.75),
  left: theme.spacing(0.75),
  zIndex: 2,
  color: 'white',
  backgroundColor: alpha('#000', 0.4),
  borderRadius: '4px',
  padding: '4px',
  '&.Mui-checked': {
    color: colors.primary.main,
    backgroundColor: alpha(colors.primary.main, 0.2),
  },
  '&:hover': {
    backgroundColor: alpha('#000', 0.5),
  },
}));

export const ImageOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  padding: theme.spacing(1),
  background: `linear-gradient(to top, ${alpha('#000', 0.75)}, transparent)`,
  color: 'white',
}));

export const CardContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0.75, 1, 0.5, 1),
}));

export const CardActionsBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(0.5),
  paddingTop: theme.spacing(0.35),
  paddingBottom: theme.spacing(0.2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(8),
}));

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
  gridColumn: '1 / -1',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(8),
  textAlign: 'center',
}));
